import React from 'react';
import './FormSection.css';
interface FormSectionProps {
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  required?: boolean;
}
const FormSection: React.FC<FormSectionProps> = ({ title, description, children, required = false }) => {
  const hasHeader = title || description;
  return (
    <div className="form-section-container">
      {hasHeader && (
        <div className="form-section-header">
          {title && (
            <h2 className="form-section-title">
              {title}
            </h2>
          )}
          {description && <p className="form-section-description">{description}</p>}
        </div>
      )}
      <div className="form-section-content">
        {children}
      </div>
    </div>
  );
};
export default FormSection;